export default __webpack_public_path__ + "static/media/9-1.542e0747.mp3";